import logoSrc from "assets/me-app-logo.svg";
import { makeBEM } from "utils";

import "./index.scss";

const bem = makeBEM("app-logo");

export const AppLogo = () => {
  return (
    <>
      <div className={bem()}>
        <img src={logoSrc} alt="Logo" className={bem("image")} />
      </div>
    </>
  );
};
